import React from 'react';
import VerticalNavbar from './VerticalNavbar';

const Layout = ({ children, showNavbar = true }) => {
    return (
        <div className="min-h-screen bg-gray-50">
            {showNavbar && <VerticalNavbar />}
            <main className={`${showNavbar ? 'lg:ml-64' : ''} transition-all duration-300`}>
                {children}
            </main>
        </div>
    );
};

export default Layout;
